import {
  Box,
  Button,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  Stack,
  TextField,
  Typography,
  Card,
  CardActions,
  Divider,
  Zoom,
} from "@mui/material";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import LoadingButton from "@mui/lab/LoadingButton";
import { useFormik } from "formik";
import PartialDelete from "./PartialDelete";

const sender = {
  firstName: "Silvia",
  middleName: "Njeri",
  lastName: "Maina",
  nickName: "SJ",
  email: "njerisylv@yahoo.com",
  primaryPhone: "0725865895",
  secondaryPhone: "",
  company: "",
  title: "",
  street: "",
  PoBox: "",
  City: "",
  county: "",
  website: "",
  birthday: "",
  label: "",
  edit: "none",
};

function Create(props) {
  const text = props === undefined ? "" : props.text;
  const [messages, setMessages] = useState([]);
  const [contacts, setContacts] = useState([]);

  //contacts
  const myContacts = async () => {
    const response = await fetch("http://127.0.0.1:8000/messenger/contacts/", {
      mode: "cors",
      method: "GET",
    });
    const fetcher = response.body.getReader();
    let data = [];
    let receivedLength = 0;
    while (true) {
      const { value, done } = await fetcher.read();
      if (done) {
        break;
      }
      data.push(value);
      receivedLength += value.length;
    }
    let chunksAll = new Uint8Array(receivedLength);
    let position = 0;
    for (let chunk of data) {
      chunksAll.set(chunk, position);
      position += chunk.length;
    }
    let result = new TextDecoder("utf-8").decode(chunksAll);

    let finalData = JSON.parse(result);
    setContacts(finalData);
    console.log(finalData);
  };

  useEffect(() => {
    myContacts();
  }, []);

  const handleAddMessage = async (message) => {
    const newMessages = [...messages, message];
    console.log(message);
  };

  // states
  const [openDialog, setOpenDialog] = useState(false);
  const [check, setCheck] = useState("Select All");
  const [selected, setSelected] = useState([]);
  const [schedule, setSchedule] = useState(null);
  const [openSchedule, setOpenSchedule] = useState(false);

  const formikForm = useFormik({
    initialValues: {
      message: text,
    },
    onSubmit: (values) => {
      const selectedContacts = contacts.filter((contact) => {
        if (contact.editMode === true) {
          return true;
        } else {
          return false;
        }
      });
      const ids = selectedContacts.map((contact) => {
        return contact.id;
      });
      const parameters = {
        url: "http://127.0.0.1:8000/messenger/send/",
        method: "POST",
        params: {
          message: values.message,
          recipients: ids,
        },
      };
      const results = PartialDelete(parameters);
      console.log(results);

      //   values.recipient = selectedContacts;
      //   handleAddMessage(values);
    },
  });

  // Buttons
  const [loadSend, setLoadSend] = useState(false);

  //functions
  const handleSchedule = () => {};

  const handleCheck = () => {
    if (check === "Select All") {
      const checking = contacts.map((cont) => {
        cont.selected = true;
        return cont;
      });
      setContacts(checking);
    } else {
      const checking = contacts.map((cont) => {
        cont.selected = false;
        return cont;
      });
      setContacts(checking);
    }
    check === "Select All" ? setCheck("Unselect All") : setCheck("Select All");
  };

  const handleApply = () => {
    const allSelected = contacts.filter((cont) => {
      return cont.editMode === true ? true : false;
    });
    const names = allSelected.map((cont) => {
      return `${cont.firstName}  ${cont.lastName}`;
    });
    setSelected(names);
    setOpenDialog(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleDraft = (msg) => {
    handleAddMessage(msg);
  };

  return (<Zoom in={true} style={{ transitionDelay: "200ms" }}>
    <Stack>
      <Typography variant="h6">New Message</Typography>
      <Divider variant="middle" />
      <Stack rowGap={1} mt={2}>
        <Box display={"flex"}>
          <Typography>Recipient(s)</Typography>
          <Button
            variant="outlined"
            sx={{ ml: "auto" }}
            onClick={() => setOpenDialog(true)}
          >
            Select Contact
          </Button>
        </Box>
        <TextField
          fullWidth
          placeholder="Seperate multiple values with comma (,)"
          size="small"
          value={selected}
        />
        <form onSubmit={formikForm.handleSubmit}>
          <TextField
            id="message"
            name="message"
            type="text"
            multiline
            minRows={4}
            maxRows={5}
            placeholder="Message Here"
            fullWidth
            value={formikForm.values.message}
            onChange={formikForm.handleChange}
          />
          <Box columnGap={2} display={"flex"} justifyContent={"space-evenly"}>
            <LoadingButton
              loading={loadSend}
              type="submit"
              onClick={formikForm.handleSubmit}
            >
              Send
            </LoadingButton>
            <Button onClick={() => setOpenSchedule(true)}>Schedule</Button>
            <Button
              onClick={() => {
                handleDraft();
              }}
            >
              Save and Send
            </Button>
            <Button onClick={handleDraft}>Save as Draft</Button>
          </Box>
        </form>
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          sx={{ width: "100vw" }}
        >
          <Card sx={{ width: "50vw" }}>
            <CardHeader title="My Contacts" />
            <CardActions>
              <Button onClick={handleCheck}>{check}</Button>
            </CardActions>
            <CardContent>
              {contacts.length > 0 ? (
                contacts.map((contact) => {
                  return (
                    <Box
                      display={"flex"}
                      key={contact.id}
                      alignItems={"center"}
                    >
                      <Checkbox
                        checked={contact.editMode}
                        onClick={() => {
                          const AlteredContacts = contacts.map((cont) => {
                            if (cont.id === contact.id) {
                              let newStatus =
                                cont.editMode === true ? false : true;
                              cont.editMode = newStatus;
                            }
                            return cont;
                          });
                          setContacts(AlteredContacts);
                        }}
                      ></Checkbox>
                      <Box display={"flex"} columnGap={2}>
                        <Typography>
                          {contact.firstName} {contact.lastName}
                        </Typography>
                        <Typography>{contact.primaryPhone}</Typography>
                      </Box>
                    </Box>
                  );
                })
              ) : (
                <Typography variant="h6">No Contacts</Typography>
              )}
            </CardContent>
            <CardActions
              sx={{ display: "flex", justifyContent: "space-evenly" }}
            >
              <Button variant="outlined" onClick={handleApply}>
                Apply
              </Button>
              <Button variant="outlined" onClick={() => setOpenDialog(false)}>
                Close
              </Button>
            </CardActions>
          </Card>
        </Dialog>
        <Dialog
          open={openSchedule}
          onClose={() => setOpenSchedule(false)}
          sx={{ width: "100vw" }}
        >
          <Card elevation={2} sx={{ width: "50vw" }}>
            <CardHeader title="Scheduler" />
            <CardContent>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "MobileDatePicker",
                    "DesktopDatePicker",
                    "StaticDatePicker",
                  ]}
                >
                  <DemoItem label="Responsive variant">
                    <DatePicker defaultValue={dayjs("2022-04-17")} />
                  </DemoItem>
                </DemoContainer>
              </LocalizationProvider>
            </CardContent>
            <CardActions>
              <Button variant="outlined">Set</Button>
              <Button variant="outlined" onClick={() => setOpenSchedule(false)}>
                Cancel
              </Button>
            </CardActions>
          </Card>
        </Dialog>
      </Stack> 
    </Stack>
    </Zoom>
  );
}

export default Create;
